import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-resolve-all-conflict',
  templateUrl: './resolve-all-conflict.component.html',
  styleUrls: ['./resolve-all-conflict.component.scss']
})
export class ResolveAllConflictComponent {
  loader: boolean = false;

  constructor(    public dialogRef: MatDialogRef<ResolveAllConflictComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any){

  }
  resolvePropertyConflict(option: number) {
    this.dialogRef.close({ success: true, option: option });
    }
}
